import { render, staticRenderFns } from "./WizardResult.vue?vue&type=template&id=5db78b31&scoped=true"
import script from "./WizardResult.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardResult.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WizardResult.vue?vue&type=style&index=0&id=5db78b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db78b31",
  null
  
)

export default component.exports